<template>
  <QsDrawer
    :title="title"
    :visible.sync="visible"
    :before-close="handleClose"
    :append-to-body="true"
    :destory-on-close="true"
  >
    <div class="drawer__content">
      <el-steps
        v-if="scene === SCENE_MAPPING.CUSTMER"
        :active="active"
        finish-status="success"
        align-center
        class="mb-4"
      >
        <el-step title="输入车辆信息"></el-step>
        <el-step title="选择所属部门"></el-step>
      </el-steps>
      <!-- 第一步 自定义时显示 -->
      <TransferVchicleDeptMore
        ref="transferVchicleDeptMoreRef"
        v-show="showNextStep"
      />
      <SubmitVchicle
        ref="submitVchicleRef"
        v-show="active === 1"
        :vechicles.sync="vechicles"
        :allCar="allCar"
      />
    </div>
    <template slot="footer">
      <div class="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button v-if="showPrevStep" @click="handlePrevStep"
          >上一步</el-button
        >
        <el-button type="primary" @click="handleSave" :loading="loading">{{
          submitText
        }}</el-button>
      </div>
    </template>
  </QsDrawer>
</template>
<script setup>
import { ref, computed } from 'vue'
import { Message } from '@qs/ui'
import TransferVchicleDeptMore from './transferVchicleDeptMore.vue'
import SubmitVchicle from './submitVchicle.vue'
import { connectCarDept } from '@/api/domain/organize'
import { SCENE_MAPPING } from '../hooks'

const emits = defineEmits(['refresh'])
const loading = ref(false)
const visible = ref(false)
// 步骤
const active = ref(0)
// 是否是自定义场景 还是 自选场景
const scene = ref(SCENE_MAPPING.CHOOSE)
// 点击全部修改
const allCar = ref(false)
const fromDeptId = ref(null)

// 最后一步的ref
const submitVchicleRef = ref(null)
// 自定义的ref
const transferVchicleDeptMoreRef = ref(null)

// 车辆信息
const vechicles = ref([])

// 是否展示上一步
const showPrevStep = computed(
  () => scene.value === SCENE_MAPPING.CUSTMER && active.value === 1,
)
// 是否展示下一步
const showNextStep = computed(
  () => scene.value === SCENE_MAPPING.CUSTMER && active.value === 0,
)
const title = computed(() =>
  (scene.value === SCENE_MAPPING.CUSTMER ? '自定义批量' : '调整部门'))

// 按钮文案
const submitText = computed(() => {
  if (showNextStep.value) {
    return '下一步'
  }
  return '确认调整部门'
})

// 点击上一步
const handlePrevStep = () => {
  active.value = 0
}

const openDrawer = ({
  list = [],
  enterScene = SCENE_MAPPING.CHOOSE,
  isAll = false,
  oriDeptId = null,
}) => {
  scene.value = enterScene
  active.value = enterScene === SCENE_MAPPING.CHOOSE ? 1 : 0
  vechicles.value = list
  allCar.value = isAll
  fromDeptId.value = oriDeptId
  visible.value = true
}
const closeDrawer = () => {
  visible.value = false
}

const handleClose = () => {
  vechicles.value = []
  active.value = 0
  allCar.value = false
  visible.value = false
}

const handleSave = async () => {
  // 点击下一步
  if (showNextStep.value) {
    const vechicleList = await transferVchicleDeptMoreRef.value.validate()
    if (!vechicleList) return
    vechicles.value = vechicleList
    active.value = 1
    return
  }
  const deptId = await submitVchicleRef.value.validate()
  if (!deptId) return
  const carIdList = vechicles.value.map((item) => item.id)
  if (carIdList.length === 0) {
    Message.warning('车辆为空，请选择车辆！')
    return
  }
  const params = {
    carIdList,
    toDeptId: deptId,
  }
  if (allCar.value) {
    params.allCar = allCar.value
    params.fromDeptId = fromDeptId.value
  }
  loading.value = true
  connectCarDept(params)
    .then(({ code }) => {
      if (code === 1) {
        Message.success('车辆调整成功')
        emits('refresh')
        handleClose()
      }
    })
    .finally(() => {
      loading.value = false
    })
}

defineExpose({
  open: openDrawer,
  close: closeDrawer,
})
</script>

<style scoped lang="scss">
::v-deep(.el-select--small) {
  width: 100% !important;
}
::v-deep(.el-form-item .el-form-item__label) {
  justify-content: flex-start;
}
::v-deep(.el-tag--small) {
  padding: 2px 8px;
  font-size: 14px;
  font-weight: normal;
  height: 24px;
  margin-bottom: 8px;
  margin-right: 8px;
}

.content-title {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  display: flex;
  align-items: center;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);
}
.drawer__content {
  padding: 0 16px;
  height: 100%;
  width: 100%;
  > .content-tagbox {
    margin-top: 8px;
    overflow: auto;
    max-height: calc(100% - 170px);
  }
}
</style>
